import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { RouterView } from "vue-router";
import Auth from "@/components/Auth.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Auth, null, {
                default: _withCtx(() => [
                    _createVNode(_unref(RouterView))
                ]),
                _: 1
            }));
        };
    }
});
